import React from "react";
import NavItem from "./NavItem/NavItem";
import classes from "./NavItems.module.css";

function NavItems() {
  return (
    <ul className={classes.NavItems}>
      <NavItem link="/">Home</NavItem>
      <NavItem link="/aboutus">About</NavItem>
      <NavItem link="/services">Services</NavItem>
      <NavItem link="/team">Team</NavItem>
      <NavItem link="/contactus">Contact us</NavItem>
    </ul>
  );
}

export default NavItems;
